module.exports = __webpack_public_path__ + "6f4fe630686ae2b85a2c091d2bd7f97a.jpg";